module.exports = __webpack_public_path__ + "img/apidays-live-hongkong-tc.06a4eb76.jpg";